import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { combineReducers } from 'redux';

// Reducers
import customerReducer from './Customer/store/customerReducer';
import deliveryNotes from './Customer/store/deliveryNoteReducer';

// Components
import CustomerList from './Customer';
import CustomerCreate from './Customer/CustomerCreate.js';
import CustomerEdit from './Customer/Details';

// Routes
export const routes = basePath =>
    (
        <Switch>
            <Route path={basePath} exact component={CustomerList} />
            <Route path={basePath + '/details'} exact component={CustomerEdit} />
            <Route path={basePath + '/create'} exact component={CustomerCreate} />

        </Switch>
    )

export const reducers = combineReducers({
    customers: customerReducer,
    deliveryNotes: deliveryNotes
});